import { render, staticRenderFns } from "./TableScoreGrade.vue?vue&type=template&id=af7617a0&scoped=true"
import script from "./TableScoreGrade.vue?vue&type=script&lang=js"
export * from "./TableScoreGrade.vue?vue&type=script&lang=js"
import style0 from "./TableScoreGrade.vue?vue&type=style&index=0&id=af7617a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7617a0",
  null
  
)

export default component.exports